import {CommonMessages} from '../common.messages';

export const PanelAccountsEditCurrentPositionsMessages = {
    GetCurrentPositionsFailed: {
        key: 'GetCurrentPositionsFailed',
        message: 'Error while communication with the server. Unable to get open position for selected account.'
    },
    ...CommonMessages
};
